.root {
  --card--border-radius: var(--theme--tokens--card--border-radius);
  --card--border-width: var(--theme--tokens--card--border-width, 1px);
  --card--border-color: var(--theme--tokens--card--border-color, var(--theme--color--grey--main));

  &.clickable {
    cursor: pointer;

    &:hover {
      box-shadow: var(--theme--shadow--md);
    }

    &:focus-visible,
    &:focus-within {
      outline: var(--theme--token--focus--outline);
      outline-offset: var(--theme--token--focus--offset);
    }

    &:focus-visible {
      box-shadow: var(--theme--shadow--md);
      outline: var(--theme--token--focus--outline);
      outline-offset: var(--theme--token--focus--offset);
    }
  }

  & {
    display: flex;
    flex-direction: column;
    border: solid var(--card--border-width) var(--card--border-color);
    background-color: var(--theme--color--mono--white);
    border-radius: var(--card--border-radius);
    overflow: hidden;
    position: relative;
    transition: all var(--theme--transition--default);
  }

  .button {
    appearance: none;
    border: none;
    background: none;
    padding: 0;
    margin: 0;
  }

  .buttonSpan {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .link {
    position: absolute;
    inset: 0;
  }
}